// 要引入這個 plugin Webpacker 才能用 `<%= image_pack_tag 'image' %>` 去插入圖片
require.context('../../images', true)
